import React, { useState, useEffect } from "react";
import '../css/ekstra.css';
import data from '../data/kategori1.json'
import kategori from '../data/kategori2.json'
import Slider2 from "../components/slider";
export default function Ekstra() {
    const [jsonData, setJsonData] = useState([]);
    const [jsonKategori, setJsonKategori] = useState([]);

    useEffect(() => {
        setJsonData(data);
        setJsonKategori(kategori);
    }, []);
    return (
        <section>

            <div className="title ekstra">Ekstrakulikuler</div>
            <Slider2 />
        </section>
    )
}